import { Box, styled } from '@mui/material';

export const Wrapper = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== 'listsHeight' && prop !== 'noPaddingBottom',
})(({ theme, listsHeight, noPaddingBottom }) => ({
  [theme.breakpoints.down('lg')]: {
    overflowY: 'auto',
    height: listsHeight,
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    msOverflowStyle: 'none',
    scrollbarWidth: 'none',
    paddingBottom: !noPaddingBottom && theme.spacing(3),
  },
}));
